import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './subheader.css';

const Subheader = (props) => {
    const { children, normalWeight, modifier } = props;
    const classList = `${styles.header}
                        ${normalWeight ? styles['header--normal-weight'] : ''}
                        ${modifier || ''}`;

    return (
        <h3 className={classList}>
            {children}
        </h3>
    );
};

Subheader.propTypes = {
    children: PropTypes.node.isRequired,
    normalWeight: PropTypes.bool,
    modifier: PropTypes.string
};

export default Subheader;
